/* eslint-disable no-undefined */
import BreadCrumb from "../../../components/BreadCrumb";
import Layout from "../../../components/Layout";
import { Grid } from "@mui/material";
import InputGroup from "../../../components/FormComponent/InputGroup";
import ReactQuill from "react-quill";
import { useState, useEffect } from "react";
import Button from "../../../components/Button";
import useStyles from "../styles";
import Modal from "../../../components/Modal";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import { httprequest } from "../../../data/api";
import { toast } from "react-toastify";
import useValidator from "../../../hooks/useValidator";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useUserState } from "../../../context/UserContext";
import TextAreaGroup from "../../../components/FormComponent/TextAreaGroup";
import emptystate from "../../../assets/images/Empty State.png";
import luluRobotImg from "../../../assets/images/lulurobot.png";
import PageLoader from "../../../components/PageLoader";
import LuluDrawer from "./LuluDrawer";

const markdownToHtml = (md) => {
  if (!md) return "";
  const lines = md.split("\n");
  const out = [];
  let i = 0;
  while (i < lines.length) {
    const line = lines[i];
    if (line.startsWith("# ")) {
      out.push(`<h1>${line.slice(2)}</h1>`);
    } else if (line.startsWith("## ")) {
      out.push(`<h2>${line.slice(3)}</h2>`);
    } else if (line.startsWith("### ")) {
      out.push(`<h3>${line.slice(4)}</h3>`);
    } else if (/^\d+\.\s/.test(line)) {
      const items = [];
      while (i < lines.length && /^\d+\.\s/.test(lines[i])) {
        items.push(`<li>${lines[i].replace(/^\d+\.\s/, "")}</li>`);
        i++;
      }
      out.push(`<ol>${items.join("")}</ol>`);
      continue;
    } else if (line.startsWith("- ")) {
      const items = [];
      while (i < lines.length && lines[i].startsWith("- ")) {
        items.push(`<li>${lines[i].slice(2)}</li>`);
        i++;
      }
      out.push(`<ul>${items.join("")}</ul>`);
      continue;
    } else if (line.trim() !== "") {
      out.push(`<p>${line}</p>`);
    } else {
      out.push("<p><br></p>");
    }
    i++;
  }

  return out.join("");
};

const GET_ALL_LESSONNOTES = "/api/v1/lesson-notes";
const POST_NOTE = "/api/v1/lesson-outlines";
const POST_DRAFT = "/api/v1/lesson-outlines/draft";
const CUSTOM_FIELDS_ENDPOINT = "api/v1/custom-fields";
const CUSTOM_FIELDS_VALUES_ENDPOINT = "api/v1/custom-fields/values";

const CreateLessonNote = () => {
  const [noteValue, setNoteValue] = useState("");
  const classes = useStyles();
  const role = useUserState();
  const { id } = useParams();
  const [confirmCreateModal, setConfrimCreateModal] = useState(false);
  const [lessonNotes, setLessonNotes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [noteValidator, showNoteValidator] = useValidator();
  const [alessonId, setLessonNoteId] = useState("");
  const [noteForm, setNoteForm] = useState({
    lesson_note_id: id,
    topic: "",
    training_method: "",
    learning_goals: "",
    learning_materials: "",
    lesson_outline: ""
  });
  const navigate = useNavigate();

  const [isFetchingCustomFields, setIsFetchingCustomFields] = useState(false);
  const [customFields, setCustomFields] = useState([]);
  const [fieldValues, setFieldValues] = useState({});
  const [isLuluOpen, setIsLuluOpen] = useState(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const subject_id = queryParams.get("subject_id");
  const class_id = queryParams.get("class_id");

  const fetchCustomFields = () => {
    setIsFetchingCustomFields(true);

    httprequest.get(`${CUSTOM_FIELDS_ENDPOINT}?scope=lesson_outlines`)
      .then((res) => {
        setIsFetchingCustomFields(false);
        const fields = res.data?.data?.fields || [];
        if (fields && Array.isArray(fields) && fields.length > 0) {
          setCustomFields(fields);

          const initialValues = {};
          fields.forEach(field => {
            let existingValue = "";

            if (field.values && Array.isArray(field.values) && field.values.length > 0) {
              const firstValue = field.values[0];
              if (firstValue && firstValue.value !== undefined) {
                existingValue = firstValue.value;
                if (Array.isArray(existingValue)) {
                  existingValue = existingValue.join(", ");
                }
              }
            }
            initialValues[field.id] = existingValue;
          });

          setFieldValues(initialValues);
        } else {
          setCustomFields([]);
          setFieldValues({});
        }
      })
      .catch(() => {
        setIsFetchingCustomFields(false);
        setCustomFields([]);
        setFieldValues({});
      });
  };

  const handleFieldChange = (fieldId, value) => {
    setFieldValues(prev => ({
      ...prev,
      [fieldId]: value
    }));
  };

  const handleConfirmCreateModal = () => {
    if (noteValidator.allValid()) {
      setConfrimCreateModal(!confirmCreateModal);
    } else {
      showNoteValidator(true);
    }
  };
  const handleAddField = () => {
    navigate("/settings?tab=custom-field&action=create");
  };

  const handleSelectClassChange = (event) => {
    setLessonNoteId(event.target.value);
  };

  const handleNoteChange = (e) => {
    const { name, value } = e.target;
    setNoteForm({ ...noteForm, [name]: value });
  };

  const handleQuillChange = (e) => {
    setNoteValue(e);
  };

  const getAllLessonNotes = () => {
    httprequest
      .get(GET_ALL_LESSONNOTES)
      .then((res) => {
        setLessonNotes(res?.data?.data);
      })
      .catch((err) => {
        toast.error(err?.response?.data);
      });
  };

  useEffect(() => {
    const matchingNote = lessonNotes.find(note => note.class?.id === class_id && note.subject?.id === subject_id
    );

    if (matchingNote) {
      setLessonNoteId(matchingNote?.id);
    }
  }, [lessonNotes, class_id, subject_id]);

  const handleCreateNote = () => {
    if (noteValidator.allValid()) {
      setIsLoading(true);

      httprequest
        .post(POST_NOTE, { ...noteForm, lesson_outline: noteValue })
        .then(() => {
          // const createdLessonOutlineId = res.data?.data?.id;

          if (customFields.length > 0 && Object.keys(fieldValues).length > 0) {
            const valuesPayload = Object.entries(fieldValues)
              .map(([fieldId, value]) => {
                let formattedValue = [];

                if (typeof value === "string" && value.trim() !== "") {
                  formattedValue = [value];
                } else if (typeof value === "number") {
                  formattedValue = [value.toString()];
                } else if (value !== undefined && value !== null && value !== "") {
                  formattedValue = [value.toString()];
                }

                return {
                  field_id: fieldId,
                  value: formattedValue
                };
              })
              .filter(item => item.value.length > 0);

            if (valuesPayload.length > 0) {
              const customFieldsPayload = {
                target_type: "lesson_outlines",
                target_id: id,
                values: valuesPayload
              };

              return httprequest.patch(CUSTOM_FIELDS_VALUES_ENDPOINT, customFieldsPayload);
            }
          }

          return Promise.resolve();
        })
        .then(() => {
          setIsLoading(false);
          setConfrimCreateModal(false);
          toast.success("Lesson note outline created successfully");
          setTimeout(() => {
            navigate(`/lesson-notes/${noteForm.lesson_note_id}`);
          }, 1000);
        })
        .catch((err) => {
          setIsLoading(false);
          toast.error(err?.response?.data?.message || "Failed to create lesson note");
        });
    } else {
      showNoteValidator(true);
    }
  };

  const handleDrafts = () => {
    setIsLoading(true);

    const newForm = new FormData();
    newForm.append("lesson_outline", noteValue);
    newForm.append("lesson_note_id", noteForm.lesson_note_id);
    newForm.append("training_method", noteForm.training_method);
    newForm.append("learning_goals", noteForm.learning_goals);
    newForm.append("learning_materials", noteForm.learning_materials);
    newForm.append("topic", noteForm.topic);

    httprequest
      .post(POST_DRAFT, newForm)
      .then((res) => {
        setIsLoading(false);
        navigate("/lesson-notes");
        toast.success(res?.data?.message);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  useEffect(() => {
    getAllLessonNotes();
    fetchCustomFields(); // Fetch custom fields on mount

    const qlContainer = document.querySelector(".ql-container");
    if (qlContainer) {
      qlContainer.style.minHeight = "140px";
      qlContainer.style.borderRadius = "0px 0px 10px 10px";
    }

    const qlToolbar = document.querySelector(".ql-toolbar.ql-snow");
    if (qlToolbar) {
      qlToolbar.style.borderRadius = "10px 10px 0px 0px";
    }
  }, []);

  const handleEditorDrop = (event) => {
    if (event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files.length > 0) {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  const handlePaste = (event) => {
    const items = event.clipboardData.items;
    for (let i = 0; i < items.length; i++) {
      if (items[i].type.indexOf("image") !== -1) {
        event.preventDefault();

        return;
      }
    }
  };

  const Quillformats = ["background", "bold", "color", "font", "code", "italic", "link", "size",
    "strike", "script", "underline", "blockquote", "header", "indent", "list", "align", "direction", "code-block", "formula"
  ];

  // Render custom field input based on field type
  const renderCustomFieldInput = (field) => {
    const value = fieldValues[field.id] || "";
    const isEditable = true;

    const commonProps = {
      margin: "normal",
      label: field.name + (field.is_required ? " *" : ""),
      inputName: `custom_field_${field.id}`,
      value,
      placeholder: field.description || field.help_text || `Enter ${field.name.toLowerCase()}`,
      onChange: (e) => handleFieldChange(field.id, e.target.value),
      required: field.is_required,
      disabled: !isEditable
    };

    switch (field.field_type?.toLowerCase()) {
    case "textarea":
      return <TextAreaGroup {...commonProps} rows={4} />;

    case "number":
      return (
        <InputGroup
          inputType="number"
          {...commonProps}
          min={field.validation_rule === "min" ? field.custom_regex : undefined}
          max={field.validation_rule === "max" ? field.custom_regex : undefined}
        />
      );

    case "date":
      return <InputGroup inputType="date" {...commonProps} />;

    case "text":
    default:
      return <InputGroup inputType="text" {...commonProps} />;
    }
  };

  return (
    <Layout
      children={
        <>
          <div className="breadcrumb-container">
            <div>
              <BreadCrumb
                link_one="/lesson-notes"
                link_one_name="Lesson Notes"
                link_two={`/lesson-notes/${id}`}
                link_two_name="All Lesson Outlines"
                active="Create Lesson Outline"
                description="Create a lesson outline in a lesson note for a class"
              />
            </div>
          </div>
          <div className="page-content">
            <Grid container spacing={2}>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <SelectGroup
                  label="Class & Subject"
                  required
                  children={
                    <select onChange={handleSelectClassChange} value={alessonId} name="lesson_note_id">
                      <option value="">--- Select ---</option>
                      {lessonNotes?.map((lessonnote) => {
                        return (
                          <option key={lessonnote?.id} value={lessonnote?.id}>
                            {lessonnote?.class?.name} | {lessonnote?.subject?.name}
                          </option>
                        );
                      })}
                    </select>
                  }
                />
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <InputGroup required label="Topic" inputType="text" inputName="topic" onChange={handleNoteChange} value={noteForm.topic} />
                {noteValidator.message("Topic", noteForm?.topic, "required")}
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <TextAreaGroup required label="Method of Teaching" inputType="text" inputName="training_method" onChange={handleNoteChange} value={noteForm.training_method} />
                {noteValidator.message("Training Method", noteForm?.training_method, "required")}
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <TextAreaGroup
                  label="Learning Objective and Goals"
                  required
                  inputType="text"
                  inputName="learning_goals"
                  onChange={handleNoteChange}
                  value={noteForm.learning_goals}
                />
                {noteValidator.message("Learning Goals", noteForm?.learning_goals, "required")}
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <TextAreaGroup required label="Learning Materials" inputType="text" inputName="learning_materials" onChange={handleNoteChange} value={noteForm.learning_materials} />
                {noteValidator.message("Learning Materials", noteForm?.learning_materials, "required")}
              </Grid>
            </Grid>
            <div className={`${classes.quillposition} margin-top-40`}>
              <p className="text-align-left no-margin-block">
                <strong>Lesson Outline</strong>
                <span className="input-required">*</span>
              </p>
              <ReactQuill
                theme="snow"
                onDrop={handleEditorDrop}
                onChange={handleQuillChange}
                onPaste={handlePaste}
                formats={Quillformats}
                modules={{
                  toolbar: [
                    [{ "header": [1, 2, false] }],
                    ["bold", "italic", "underline"],
                    [{ "list": "ordered" }, { "list": "bullet" }],
                    ["clean"]
                  ]
                }}
                value={noteValue}
                style={{
                  minHeight: "200px",
                  borderRadius: 20,
                  textAlign: "left",
                  "& qlContainer": { height: "150px" }
                }}
              />
              {noteValidator.message("Learning Content", noteValue, "required")}

              <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "10px" }}>
                <div className={classes.luluContainer} onClick={() => setIsLuluOpen(true)}>
                  <img src={luluRobotImg} alt="Lulu AI" />
                  <p>Use lulu</p>
                </div>
              </div>
            </div>
            <div className={classes.custom}>
              <div className={classes.customheading}>
                <div>
                  <h3>Custom Fields</h3>
                  <p>Add custom metadata for this lesson.</p>
                </div>
                <Button
                  variant="primary"
                  buttonSize="fluid"
                  color="btndefault"
                  buttonName="Add Field"
                  onClick={handleAddField}
                />
              </div>

              {isFetchingCustomFields ? (
                <div className={classes.emptyStateBox}>
                  <PageLoader />
                </div>
              ) : customFields.length === 0 ? (
                <div className={classes.emptyStateBox}>
                  <img src={emptystate} alt="empty" />
                  <h4>No Custom Fields</h4>
                  <p>No custom fields have been defined for lesson outlines.</p>
                </div>
              ) : (
                <Grid container spacing={2} className={classes.customList}>
                  {customFields.map((field) => (
                    <Grid item lg={6} md={6} sm={12} xs={12} key={field.id}>
                      {renderCustomFieldInput(field)}
                      {field.description && (
                        <small style={{ display: "block", marginTop: "5px", color: "#666", fontSize: "12px" }}>
                          {field.description}
                        </small>
                      )}
                      {field.help_text && (
                        <small style={{ display: "block", marginTop: "5px", color: "#888", fontSize: "11px" }}>
                          {field.help_text}
                        </small>
                      )}
                    </Grid>
                  ))}
                </Grid>
              )}
            </div>

            <div className={classes.luluSection}>
              <div className="flex gap-10 flex-wrap-items-426">
                <Button
                  variant="primaryoutline"
                  buttonSize="fluid"
                  color="btnfontprimary"
                  buttonName="Save as Drafts"
                  onClick={handleDrafts}
                  isLoading={isLoading}
                  disabled={isLoading}
                />
                <Button
                  variant="primary"
                  buttonSize="fluid"
                  color="btndefault"
                  onClick={handleConfirmCreateModal}
                  buttonName={role?.userRole?.role === "school_admin" ? "Submit" : "Submit for Review"}
                />
              </div>
            </div>
          </div>
          <LuluDrawer
            open={isLuluOpen}
            onClose={() => setIsLuluOpen(false)}
            lessonNotes={lessonNotes}
            onApplyContent={(content) => {
              if (content?.topic) setNoteForm((prev) => ({ ...prev, topic: content.topic }));
              if (content?.training_method) setNoteForm((prev) => ({ ...prev, training_method: content.training_method }));
              if (content?.learning_goals) setNoteForm((prev) => ({ ...prev, learning_goals: content.learning_goals }));
              if (content?.learning_materials) setNoteForm((prev) => ({ ...prev, learning_materials: content.learning_materials }));
              if (content?.lesson_outline) setNoteValue(markdownToHtml(content.lesson_outline));
              if (content?.lessonNote?.id) {
                setLessonNoteId(content.lessonNote.id);
                setNoteForm((prev) => ({ ...prev, lesson_note_id: content.lessonNote.id }));
              }
            }}
          />
          {/* Create Confirmation Modal */}
          <Modal
            title="Create Lesson Note Outline"
            subtitle={
              <div>
                Clicking on create sends a confirmation to your manager for
                review
              </div>
            }
            modalContent={<></>}
            modalFooter={
              <>
                <Button
                  variant="primary"
                  buttonSize="full"
                  color="btndefault"
                  buttonName="Create Lesson Note Outline"
                  isLoading={isLoading}
                  onClick={handleCreateNote}
                />
              </>
            }
            isopen={confirmCreateModal}
            closeModal={handleConfirmCreateModal}
          />
        </>
      }
    />
  );
};

export default CreateLessonNote;
